import { render, staticRenderFns } from "./KBUG.vue?vue&type=template&id=7fe860c1&"
import script from "./KBUG.vue?vue&type=script&lang=js&"
export * from "./KBUG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports